import React from 'react';
import { useSelector } from 'react-redux';
import Categories from '../Categories/Categories';

const HomeCategories = () => {
  const categoryList = useSelector((state) => state.categories.list);
  const productList = useSelector((state) => state.products.list);

  return (
    <Categories
      products={categoryList}
      productList={productList}
      title="Категорії товарів"
    />
  );
};

export default HomeCategories;
